import React, { useState } from 'react';
import { Input, Select, Button } from 'antd';
import { useHistory } from 'react-router-dom';

import { useApi } from '../../../hooks/useApi';
import { formatPrice } from '../../../data/helpers';

import {
  SidebarWrapper,
  SidebarSection,
  SidebarTitle,
  CategoryList,
  CategoryItem,
  CategoryLink,
  CategoryCount,
  StatGrid,
  StatBox,
  StatNumber,
  StatLabel,
  RecentItem,
  RecentImage,
  RecentInfo,
  RecentTitle,
  RecentPrice,
} from './styles';

export default function Sidebar() {
  const history = useHistory();
  const [searchType, setSearchType] = useState('titulo');
  const [searchValue, setSearchValue] = useState('');

  const { data: categories } = useApi('/categories');
  const { data: recentBooks } = useApi('/books/recent?count=4');

  const handleAdvancedSearch = () => {
    if (searchValue.trim()) {
      history.push(`/buscar?q=${encodeURIComponent(searchValue.trim())}&tipo=${searchType}`);
      setSearchValue('');
    }
  };

  return (
    <SidebarWrapper>
      <SidebarSection>
        <SidebarTitle>Categorías</SidebarTitle>
        <CategoryList>
          {(categories || []).map((cat) => (
            <CategoryItem key={cat.id}>
              <CategoryLink to={`/buscar?categoria=${cat.id}`}>
                {cat.name}
                <CategoryCount>({cat.count})</CategoryCount>
              </CategoryLink>
            </CategoryItem>
          ))}
        </CategoryList>
      </SidebarSection>

      <SidebarSection>
        <SidebarTitle>Estadísticas</SidebarTitle>
        <StatGrid>
          <StatBox>
            <StatNumber>15,254</StatNumber>
            <StatLabel>Libros</StatLabel>
          </StatBox>
          <StatBox>
            <StatNumber>1,287</StatNumber>
            <StatLabel>Vendedores</StatLabel>
          </StatBox>
          <StatBox>
            <StatNumber>7,589</StatNumber>
            <StatLabel>Ventas</StatLabel>
          </StatBox>
          <StatBox>
            <StatNumber>97%</StatNumber>
            <StatLabel>Satisfacción</StatLabel>
          </StatBox>
        </StatGrid>
      </SidebarSection>

      <SidebarSection>
        <SidebarTitle>Recientes</SidebarTitle>
        {(recentBooks || []).map((book) => (
          <RecentItem key={book.id} to={`/libro/${book.id}`}>
            <RecentImage>
              <img src={book.coverImage} alt={book.title} />
            </RecentImage>
            <RecentInfo>
              <RecentTitle>{book.title}</RecentTitle>
              <RecentPrice>{formatPrice(book.price)}</RecentPrice>
            </RecentInfo>
          </RecentItem>
        ))}
      </SidebarSection>

      <SidebarSection>
        <SidebarTitle>Buscar</SidebarTitle>
        <Select
          value={searchType}
          onChange={setSearchType}
          style={{ width: '100%', marginBottom: 8 }}
          options={[
            { value: 'titulo', label: 'Título' },
            { value: 'autor', label: 'Autor' },
            { value: 'isbn', label: 'ISBN' },
            { value: 'keyword', label: 'Palabra clave' },
          ]}
        />
        <Input
          placeholder={`Buscar por ${searchType}...`}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onPressEnter={handleAdvancedSearch}
          style={{ marginBottom: 8 }}
        />
        <Button
          type="primary"
          block
          onClick={handleAdvancedSearch}
        >
          Buscar
        </Button>
      </SidebarSection>
    </SidebarWrapper>
  );
}
